module.exports = __webpack_public_path__ + "img/warning.7a3f95ce.svg";